import { gql } from "graphql-tag"

const typeLocalStrings = gql`
  type LocaleString {
    id: ID!
    key: String
    text: String
  }

  type Query {
    localeStrings(lang: String, cdn: Boolean = true, drafts: Boolean = false): [LocaleString!]!
  }
`

export { typeLocalStrings }

export default typeLocalStrings
